import style from "./account.module.scss";
import packageJson from "../../../package.json";
import useAccountActions from "../../hooks/useAccountActions";

const version = packageJson.version;

const Logout = () => {
  const { logout } = useAccountActions();

  return (
    <div className={style.logout}>
      <button className={style.logoutButton} onClick={logout}>
        Log out
      </button>
      <p className={style.version}>v&nbsp;{version}</p>
    </div>
  );
};

export default Logout;
